import CheckoutStore from '../store/CheckoutStore';
import {
  BusinessDetails,
  CustomerDetails,
  OrderDetails,
  PurchaseInformation,
} from '../types';

export const createSetPurchaseInfo = (store: CheckoutStore) => {
  return async (purchaseInfo: Nullable<PurchaseInformation>): Promise<void> => {
    console.warn(
      'setPurchaseInfo has been deprecated, use setOrderDetails instead',
    );
    store.setPurchaseInfo(purchaseInfo);
  };
};

export const createSetCustomerDetails = (
  store: CheckoutStore,
  orderDetailsInitiator: string,
) => {
  return async (customerDetails: Nullable<CustomerDetails>): Promise<void> => {
    store.setCustomerDetails(customerDetails, orderDetailsInitiator);
  };
};

export const createSetBusinessDetails = (
  store: CheckoutStore,
  orderDetailsInitiator: string,
) => {
  return async (businessDetails: Nullable<BusinessDetails>): Promise<void> => {
    store.setBusinessDetails(businessDetails, orderDetailsInitiator);
  };
};

export const createSetOrderDetails = (
  store: CheckoutStore,
  orderDetailsInitiator: string,
) => {
  return async (orderDetails: Nullable<OrderDetails>): Promise<void> => {
    store.setOrderDetails(orderDetails, orderDetailsInitiator);
  };
};
